module.exports = __webpack_public_path__ + "static/media/icon_map_arrow.48ab5977.svg";